import React, { useState } from "react";
import {Scoodle2FA} from "../../../components/05pages/scoodle/Scoodle2FA/Scoodle2FA";
import QueryString from "querystring";

export const Scoodle2FAPage : React.FC = props => {
    const queryString = QueryString.parse(window.location.search.substring(1));
    const returnUrl = queryString["returnUrl"] as string;
    const [remember, setRemember] = useState(false);

    return <Scoodle2FA onRememberChanged={setRemember}
        onConfirm={() => window.location.href = '/Scoodle2FA/Start?returnUrl=' + encodeURIComponent(returnUrl) + '&remember=' + remember } />
}